import { createSelector } from '@ngrx/store';
import { selectFeatureVehicle } from '../../../store/app.selectors';

export const selectLoadingStatus = createSelector(
  selectFeatureVehicle,
  state => state.loadingStatus
);
export const selectVehicles = createSelector(selectFeatureVehicle, state => state.vehicles);
/** @deprecated superseded by loadable, use `selectVehicles` instead */
export const selectVehicleList = createSelector(selectFeatureVehicle, state => state.vehicleList);
export const selectVehicleBrands = createSelector(selectFeatureVehicle, state => state.brands);
export const selectFleets = createSelector(selectFeatureVehicle, state => state.fleets);
/** @deprecated superseded by loadable, use `selectVehicles` instead */
export const selectFleetList = createSelector(selectFeatureVehicle, state => state.fleetList);
export const selectFleetMap = createSelector(selectFeatureVehicle, state => state.fleetMap);

export const selectProviderCredentials = createSelector(
  selectFeatureVehicle,
  state => state.providerCredentials
);
